import createJQueryObjectFromString from '@intercom/embercom-composer/lib/create-jquery-object-from-string';
import $ from 'jquery';
const isTopLevelNode = function (node) {
  return node.nodeName === 'P' || node.nodeName === 'H1' || node.nodeName === 'H2' || node.nodeName === 'OL' || node.nodeName === 'UL' || node.nodeName === 'DIV' || node.nodeName === 'IFRAME' || node.className === 'intercom-h2b-button';
};
const removeBlockedElements = function (text) {
  let $content = createJQueryObjectFromString(text);
  $content.find('*').each(function () {
    if ($(this).is('meta, title, style, link')) {
      $(this).empty().remove();
    }
  });
  return createJQueryObjectFromString($.trim($content.html()));
};
const isLineBreakBesideAToplevelNode = function (node, i, contents) {
  return node.nodeType === node.TEXT_NODE && i > 0 && isTopLevelNode(contents[i - 1]) && /^\r?\n$/.test(contents[i].textContent);
};
const isBrTagBesideAToplevelNode = function (node, i, contents) {
  return node.nodeType === node.ELEMENT_NODE && i > 0 && isTopLevelNode(contents[i - 1]) && contents[i].tagName === 'BR';
};
const removeUnnecessaryLineBreaks = function ($content) {
  let contents = $content.contents();
  for (let i = 0, length = contents.length; i < length; i++) {
    let node = contents[i];
    if (isLineBreakBesideAToplevelNode(node, i, contents) || isBrTagBesideAToplevelNode(node, i, contents)) {
      $(node).remove();
    }
  }
};
export default function (html) {
  let $content = removeBlockedElements(html);
  removeUnnecessaryLineBreaks($content);
  return $content.html();
}